module.exports = __webpack_public_path__ + "img/feature_b01.2f91ce38.svg";